<template>
	<Accordion
		:open="true"
		:title="$I18n.trans('highlights.audio_detection.tagging.title')"
		icon="c-info"
		:icon-hint="$I18n.trans('highlights.audio_detection.tagging.hint')"
	>
		<HighlightDetectionWidget />
	</Accordion>
</template>
<script>
import Accordion from '@components/accordion/Accordion';
import { mapGetters, mapActions } from 'vuex';
import { getDuration } from '@shared/utils/timeUtils';
import { getPeriods } from '@js/logic/game';
import HighlightDetectionWidget from '@js/one/components/highlights/HighlightDetectionWidget';

export default {
	name:       'HighlightSection',
	components: { Accordion, HighlightDetectionWidget },
	data() {
		return {
			settings: {
				gamePhasesOnly: false,
				enhancedAi:     false,
				profile:        'full',
				createTags:     true,
			},
			profileOptions: [
				{
					label: $I18n.trans('highlights.audio_detection.profiles.full'),
					value: 'full',
				},
				{
					label: $I18n.trans('highlights.audio_detection.profiles.audience'),
					value: 'audience',
				},
				{
					label: $I18n.trans('highlights.audio_detection.profiles.referee'),
					value: 'referee',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			state:       'highlights/state',
			job:         'highlights/job',
			isRunning:   'highlights/isRunning',
			isCreated:   'highlights/isCreated',
			isCompleted: 'highlights/isCompleted',
			isIdle:      'highlights/isIdle',
			progressPct: 'highlights/progressPct',
			sportName:   'event/sportName',
			event:       'event/event',
			tags:        'event/tags',
		}),
	},
	watch: {
		tags: {
			handler() {
				if (getPeriods({
					event: this.event,
					tags:  this.tags,
				}).filter(period => period.type === 'action').length > 0) {
					this.settings.gamePhasesOnly = true;
				}
			},
			immediate: false,
		},
	},
	mounted() {
		this.loadJobByEvent();
	},
	methods: {
		...mapActions({
			startDetection: 'highlights/startDetection',
			cancelJob:      'highlights/cancelJob',
			loadJobByEvent: 'highlights/loadJobByEvent',
		}),
		getDuration,
		initDetection: function() {
			this.startDetection(this.settings);
		},
	},
};
</script>

<style lang="scss" scoped>

.hl-detection-status__icon,
.hl-detection__loading-spinner {
	margin: 10px 15px 10px 0;
}

.hl-detection-status {
    display: flex;
    align-items: center;
	margin-bottom: 20px;
}
</style>
